import useNativeMessages, {
	useNativeMessageCallback,
} from '@/hooks/native/useNativeMessages';
import { FC } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const DeepLink: FC = () => {
	const navigate = useNavigate();
	const location = useLocation();

	const onNativeMessage = useNativeMessageCallback(
		(key, value) => {
			switch (key) {
				case 'link.open':
					if (value) {
						const url = new URL(value);

						// Check if not already on this path
						if (location.pathname === url.pathname) {
							return;
						}

						// Get only the path and search parameters part from the url
						const path = url.pathname + url.search;
						// Navigate to the path
						navigate(path);
					}
					break;
			}
		},
		[navigate, location],
	);

	useNativeMessages(onNativeMessage, ['link.open']);

	return null;
};

export default DeepLink;
